import { useMemo } from 'react';

import type { ContentTypesHeaderQueryNode } from './ContentTypesHeader';
import type { LastEditedVersion } from './object-header-items/LastEdited';

type UseObjectHeaderVersionType = {
	contentData: ContentTypesHeaderQueryNode | null | undefined;
	useDraftVersion: boolean;
};

/**
 * Constructs Version data for LastEdited, from Version or DraftVersion
 */
export const useObjectHeaderVersion = ({
	contentData,
	useDraftVersion,
}: UseObjectHeaderVersionType): LastEditedVersion => {
	const version = useMemo<LastEditedVersion>(() => {
		if (useDraftVersion) {
			return {
				contentTypeModified: contentData?.draftVersion?.contentTypeModified ?? false,
				number: contentData?.draftVersion?.number ?? 1,
				when: contentData?.draftVersion?.when ?? '',
				friendlyWhen: contentData?.draftVersion?.friendlyWhen ?? '',
				by: {
					fullName: contentData?.draftVersion?.by?.displayName ?? '',
				},
			};
		}

		return {
			contentTypeModified: contentData?.version?.contentTypeModified ?? false,
			number: contentData?.version?.number ?? 1,
			when: contentData?.version?.when ?? '',
			friendlyWhen: contentData?.version?.friendlyWhen ?? '',
			by: {
				fullName: contentData?.version?.by?.displayName ?? '',
			},
		};
	}, [contentData, useDraftVersion]);

	return version;
};
